import React from 'react';
import { RichTextBlock } from 'prismic-reactjs';
import { ImageProps } from '@components/image';
import Wrapper from '@components/wrapper.styled';
import Section from '@components/section';
import Text from '@components/text';
import AnimatedElement from '@components/animated-element';
import {
  LeaderGrid,
  Subheading,
  BioCard,
  TextContainer,
  StyledImage,
  ImageContainer,
  TitleContainer,
  Divider,
  NameContainer,
  TeamWrapper,
  MainInfoContainer,
} from './meet-the-leaders.styled';

export interface ItemProps {
  image?: ImageProps;
  name?: {
    text?: string;
  };
  job_title?: {
    richText: RichTextBlock[];
  };
  description?: {
    richText: RichTextBlock[];
  };
}

interface MeetTheLeadersProps {
  items?: ItemProps[];
  title?: string;
  positions_title?: string;
  items_per_row?: number;
}

const MeetTheLeaders = ({
  items = [],
  title,
  positions_title,
  items_per_row,
}: MeetTheLeadersProps): JSX.Element => {
  if (!title && !positions_title && !items) {
    return <></>;
  }

  return (
    <Section backgroundColor="white">
      <Wrapper>
        <TeamWrapper>
          <TitleContainer>
            <AnimatedElement animationType="scaleX" delay={0.25} threshold={1} rootMargin="50px">
              <Divider />
            </AnimatedElement>
            {title && (
              <Text
                fontSize="heading2"
                type="title"
                stringText={title}
                margin="none"
                fontColor="black"
              />
            )}
            {positions_title && (
              <Subheading
                fontSize="heading3"
                type="title"
                stringText={positions_title}
                margin="none"
              />
            )}
          </TitleContainer>
          <LeaderGrid items_per_row={items_per_row}>
            {items?.map(({ image, name, job_title, description }) => {
              if (!image || !name?.text || !job_title?.richText) return null;
              return (
                <BioCard key={name.text}>
                  <MainInfoContainer>
                    <ImageContainer>
                      <StyledImage
                        url={image.url || ''}
                        alt={image.alt || name.text || 'Portrait image'}
                        gatsbyImageData={image.gatsbyImageData}
                        loading="lazy"
                        objectFit="cover"
                      />
                    </ImageContainer>
                    <NameContainer>
                      <Text
                        tag="h3"
                        type="title"
                        stringText={name.text}
                        fontSize="heading4"
                        margin="none"
                        fontColor="black"
                      />
                      <Text
                        type="subheading"
                        richText={job_title.richText}
                        fontSize="large"
                        margin="none"
                        fontColor="darkPurple"
                      />
                    </NameContainer>
                  </MainInfoContainer>
                  <TextContainer>
                    {description?.richText && (
                      <Text
                        type="description"
                        richText={description.richText}
                        fontSize="body"
                        margin="none"
                        fontColor="dark"
                      />
                    )}
                  </TextContainer>
                </BioCard>
              );
            })}
          </LeaderGrid>
        </TeamWrapper>
      </Wrapper>
    </Section>
  );
};

export default MeetTheLeaders;
